<template>
  <el-table-column
    prop="address.street"
    label="Cím"
    show-overflow-tooltip
    min-width="250"
    sortable="custom"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.address" style="display: inline-block;">
        {{ scope.row.address.street }} {{ scope.row.address.street_suffix }} {{
          scope.row.address.street_no }}.<span
          v-if="scope.row.address.floor"
        > {{ scope.row.address.floor }}. emelet</span><span
          v-if="scope.row.address.door_no"
        > {{ scope.row.address.door_no }}. ajtó</span>
      </div>
      <div v-else>-</div>
    </template>
  </el-table-column>
</template>
<script>
export default {
  propName: 'address.street',
};
</script>
